import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
import logo from './logo.svg';
import './App.css';
import TestEmail from './Pages/TestEmail';
import Testimonials from './Pages/Testimonials';
import Contact from './Pages/Contact';
import Blog from './Pages/Blog';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import ProtectedRoute from './Components/auth/ProtectedRoutes';
import AdminLayout from './Components/Admin/AdminLayout';
import DashboardPage from './Pages/Admin/DashboardPage';
import BlogList from './Pages/Blog';
import BlogEditPage from './Pages/Admin/BlogEditPage';
import SubscriberListPage from './Pages/Admin/SubscribersListPage';
import Unsubscribe from './Components/Unsubscribe';
import LoginPage from './Pages/Auth/Login';
import ForgotPasswordPage from './Pages/Auth/ForgotPassword';
import BlogListPage from './Pages/Admin/BlogListPage';
import BlogDetail from './Components/Blog/BlogDetail';
import { Helmet } from 'react-helmet';
import useAdSense from './hooks/useAdSense';
import AdsManagementPage from './Pages/Admin/AdsManagementPage';
import AdAnalyticsPage from './Pages/Admin/AdAnalyticsPage';

const ConditionalNavbar = () => {
  const location = useLocation();
  const nonAdminRoutes = ['/', '/about', '/testimonials', '/contact', '/blog']; // Routes where navbar should appear
  return nonAdminRoutes.includes(location.pathname) ? <Navbar /> : null;
};

const ConditionalFooter = () => {
  const location = useLocation();
  const nonAdminRoutes = ['/', '/about', '/testimonials', '/contact', '/blog']; // Routes where footer should appear
  return nonAdminRoutes.includes(location.pathname) ? <Footer /> : null;
}

export default function App() {
  useAdSense();
  return (
    <Router>
      <div className="App text-gray-900" style={{ textAlign: 'left', alignContent: 'center' }}>
        <Helmet>
          <title>Confessions of a Nutrition Freak</title>
          <meta name="description" content="Confessions of a Nutrition Freak is a platform that provides nutrition and wellness coaching services to help you achieve your health goals." />
          <meta name="keywords" content="nutrition, wellness, health, fitness, lifestyle, coaching, nutritionist, wellness coach, health coach" />
          <meta name="author" content="Mwende Kivale" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="google-adsense-account" content="ca-pub-8626961699894922" />
        </Helmet>
        <ConditionalNavbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/test-email" element={<TestEmail />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin/*" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="blogs" element={<BlogListPage />} />
            <Route path="blogs/new" element={<BlogEditPage />} />
            <Route path="blogs/edit/:id" element={<BlogEditPage />} />
            <Route path="subscribers" element={<SubscriberListPage />} />
            <Route path="unsubscribe" element={<Unsubscribe />} />
            <Route path="test-email" element={<TestEmail />} />
            <Route path="ads" element={<AdsManagementPage />} />
            <Route path="ads/analytics" element={<AdAnalyticsPage />} />
            <Route path="*" element={<DashboardPage />} />
          </Route>
        </Routes>
        <ConditionalFooter />
      </div>
    </Router>
  );
}
